export default function React_Class() {
  return (
    <div>
      <h1>React_Class Component</h1>
      <p>This is the React_Class tutorial page.</p>
    </div>
  );
}
